import { GoogleMap } from "./googleMap.js";
import MapStateManager from "./mapStateManager.js";
import { importLibrary } from "@googlemaps/js-api-loader";

const main = () => {
    if (!document.querySelector(".js-search-map")) return;

    const stateManager = new MapStateManager();
    const searchForm = document.querySelector(".js-search-map__types");
    const keywordInput = document.querySelector(".js-search-map__keyword");

    const apiKey =
        document
            .querySelector('meta[name="google-api-key"]')
            ?.getAttribute("content") || "";
    const mapId =
        document
            .querySelector('meta[name="google-map-id"]')
            ?.getAttribute("content") || "";

    // 既定位置（選択中の都道府県の県庁所在地、または引き継いだ駅）。
    // 県庁所在地のときは、物件があれば密集地点へ寄せ直す（GoogleMap::resolveInitialCenter）。
    // meta が無いのは総合版・エリア未確定のときで、その場合は consts の既定に任せる
    const metaNumber = (name) => {
        const raw = document
            .querySelector(`meta[name="${name}"]`)
            ?.getAttribute("content");
        if (raw === undefined || raw === null || raw === "") return null;

        const value = Number(raw);
        return Number.isFinite(value) ? value : null;
    };
    const defaultLat = metaNumber("map-default-lat");
    const defaultLng = metaNumber("map-default-lng");
    const defaultZoom = metaNumber("map-default-zoom");
    // 中心を駅で決めたときだけ出る。無ければ受け取った物件の密集地点へ寄せ直す
    const centerFixed =
        document.querySelector('meta[name="map-center-fixed"]') !== null;

    // 一覧から引き継いだ市区町村を囲む矩形。サーバー側が保存済みの座標から作るので、
    // 出ていれば必ず4隅が揃っている（App\Support\Map\MapViewport::hasBounds）。
    // それでも4隅を検査するのは、meta が欠けたときに壊れた枠へ寄せないため
    const fitNeLat = metaNumber("map-fit-ne-lat");
    const fitNeLng = metaNumber("map-fit-ne-lng");
    const fitSwLat = metaNumber("map-fit-sw-lat");
    const fitSwLng = metaNumber("map-fit-sw-lng");
    const fitBounds =
        fitNeLat !== null &&
        fitNeLng !== null &&
        fitSwLat !== null &&
        fitSwLng !== null
            ? { north: fitNeLat, east: fitNeLng, south: fitSwLat, west: fitSwLng }
            : null;

    // キー未設定でダミー地図に切り替えると実在しない物件を出すことになるため、
    // 地図自体を出さずに理由だけ表示する
    if (!apiKey || !mapId) {
        console.error(
            "Google Maps APIキーまたはMap IDが未設定のため地図を表示できません（services.google.api_key / services.google.map_id を確認してください）"
        );
        stateManager.showError(
            "地図を表示できません。管理者にお問い合わせください。"
        );
        return;
    }

    const googleMap = new GoogleMap(
        {
            api_key: apiKey,
            map_id: mapId,
            default_center:
                defaultLat !== null && defaultLng !== null
                    ? { lat: defaultLat, lng: defaultLng }
                    : null,
            default_zoom: defaultZoom,
            center_fixed: centerFixed,
            // 一覧から引き継いだエリアを囲む矩形。無ければ既定位置のまま
            fit_bounds: fitBounds,
        },
        stateManager
    );

    const moveMapByKeyword = async (keyword) => {
        const q = String(keyword || "").trim();
        if (!q) return;

        // 読み込み完了前に検索されても取りこぼさないよう地図の準備を待つ
        await googleMap.ready;
        if (!googleMap.map) return;

        try {
            const { Geocoder } = await importLibrary("geocoding");
            const geocoder = new Geocoder();
            const { results } = await geocoder.geocode({
                address: q,
                region: "jp",
                language: "ja",
            });
            const loc = results?.[0]?.geometry?.location;
            if (!loc) return;
            googleMap.map.panTo(loc);
            googleMap.map.setZoom(Math.max(googleMap.map.getZoom() || 12, 14));
        } catch (error) {
            console.error("地域・駅名の検索に失敗しました:", error);
        }
    };

    // 送信ボタンは form 内の submit ボタンなので、submit を拾えば Enter 押下も含めて拾える
    searchForm?.addEventListener("submit", (e) => {
        e.preventDefault();
        moveMapByKeyword(keywordInput?.value);
    });
};

export default main;
